module.exports = __webpack_public_path__ + "static/media/terms007.1f9a9cd3.png";